import { Button } from "@/components/ui/button";
import { SlidersHorizontal } from "lucide-react";

interface PropertyHeaderProps {
  activeCategoryName: string;
  setShowFilterSheet: (open: boolean) => void;
  // Removed searchQuery, setSearchQuery, handleSearch as PropertySearchBar will be separate
}

const PropertyHeader = ({
  activeCategoryName,
  setShowFilterSheet,
}: PropertyHeaderProps) => {
  return (
    <div className="mb-4">
      {" "}
      {/* Adjusted margin */}
      <div className="flex items-center justify-between gap-4">
        <h1 className="text-3xl font-bold text-realestate-darkblue">
          {activeCategoryName}{" "}
          {/* Simplified title, context of "Commercial Properties" can be outside or part of activeCategoryName */}
        </h1>
        {/* Mobile Filters Toggle - Only visible below md */}
        <div className="md:hidden flex-shrink-0">
          <Button
            variant="outline"
            size="icon"
            className="p-2 text-gray-500"
            onClick={() => setShowFilterSheet(true)}
            aria-label="Open filters"
          >
            <SlidersHorizontal className="w-5 h-5" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PropertyHeader;
